import React, { useState } from "react";

import { Page } from "../../layouts/Page";
import { OrderPageHeader, OrderList } from "../../molecules/OrderList";
import {
  useOrderList,
  useExportOrders,
  useFilters,
  useUpdateOrderStatus
} from "./hooks";
import { TABLE_COLUMNS } from "./constants";
import { Tab, Tabs } from "@blueprintjs/core";

function Orders() {
  const { filters, filterOptions, setFilters, isFiltersLoading } = useFilters();
  const [sort, setSort] = useState({ field: "id", direction: "desc" });
  const [selectedTab, setSelectedTab] = useState("orders");

  const { loading, loadingMore, orders, refetch } = useOrderList({
    sort,
    filters
  });

  const { onExportPress, isExportLoading } = useExportOrders({ sort, filters });
  const { onStatusChange } = useUpdateOrderStatus({ refetch });

  const nonDonationOrders = orders.filter((o) => !o.isDonation);
  const donationOrders = orders.filter((o) => o.isDonation);

  function onSortPress(field, direction) {
    setSort({ field, direction });
  }

  return (
    <Page title="Orders &amp; Donations" flex>
      <OrderPageHeader
        filters={filters}
        filterOptions={filterOptions}
        setFilters={setFilters}
        onExportPress={onExportPress}
        isExportLoading={isExportLoading}
      />
      <Tabs selectedTabId={selectedTab} onChange={setSelectedTab}>
        <Tab
          id="orders"
          title="Orders"
          panel={
            <OrderList
              loadingMore={loadingMore}
              isLoading={loading || isFiltersLoading}
              columns={TABLE_COLUMNS}
              orders={nonDonationOrders}
              onStatusChange={onStatusChange}
              onSortPress={onSortPress}
              sort={sort}
            />
          }
        />
        <Tab
          id="donations"
          title="Donations"
          panel={
            <OrderList
              loadingMore={loadingMore}
              isLoading={loading || isFiltersLoading}
              columns={TABLE_COLUMNS}
              emptyMessage="No Donations Found"
              orders={donationOrders}
              onStatusChange={onStatusChange}
              onSortPress={onSortPress}
              sort={sort}
            />
          }
        />
      </Tabs>
    </Page>
  );
}

export default Orders;
